import { render, staticRenderFns } from "./EnemyCard.vue?vue&type=template&id=afde150e&scoped=true&"
import script from "./EnemyCard.vue?vue&type=script&lang=js&"
export * from "./EnemyCard.vue?vue&type=script&lang=js&"
import style0 from "./EnemyCard.vue?vue&type=style&index=0&id=afde150e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afde150e",
  null
  
)

export default component.exports